import { Currency } from "@redotech/money/currencies";
import { conversationCategorySchema } from "@redotech/redo-model/conversation";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const conciergeMetrics = z.object({
  engagedSessionConversionRate: z.number(),
  sessionConversionRate: z.number(),
  ordersGenerated: z.number(),
  engagementRate: z.number(),
  revenueGenerated: z.number(),
  averageOrderValue: z.number(),
  shopCurrency: createEnum(Currency),
  deflectedTickets: z.number(),
  //  addToCartRate: z.number(),
  totalProductRecommendations: z.number(),
});

export const getShopperAiDashboardMetrics = {
  name: "getShopperAiDashboardMetrics" as const,
  input: z.object({
    dateRange: z.object({ start: z.date(), end: z.date() }),
    attributionWindow: z.number().optional(),
  }),
  output: z.object({
    current: conciergeMetrics,
    previous: conciergeMetrics,
    conversationCategories: z.array(conversationCategorySchema),
    overallConversionOverTime: z.map(z.date(), z.number()),
    engagedConversionOverTime: z.map(z.date(), z.number()),
    nonEngagedConversionOverTime: z.map(z.date(), z.number()),
  }),
};
